import React, { useState } from "react"
import { FormControl, Grid, MenuItem, Select, TextField } from "@material-ui/core"
import { Autocomplete } from "@material-ui/lab"
import useDidMount from "@/hooks/useDidMount"
import UserInInstanceService from "@/services/UserInInstance"
import { UserInInstance } from "@/protocols/userInInstance"
import { ConditionOperator, ContactsFiltersConditions, FilterType } from "@/protocols/ClientCatalogFilterProtocol"

type AccountManagerOperatorSlug = "equal" | "not_equal"

const operatorOptions: { value: AccountManagerOperatorSlug; label: string }[] = [
	{ value: "equal", label: "Igual" },
	{ value: "not_equal", label: "Não é igual" }
]

type ContactAccountManagerFilterConditionProps = {
	condition: ContactsFiltersConditions<"contact_account_manager">
	onChange: (condition: ContactsFiltersConditions<FilterType>) => void
}

const ContactAccountManagerFilterCondition: React.FC<ContactAccountManagerFilterConditionProps> = ({
	condition,
	onChange
}) => {
	const [attendants, setAttendants] = useState<UserInInstance[]>([])

	useDidMount(async () => {
		const data = await UserInInstanceService.getUsersInInstance({
			type: ["human"],
			status: ["active"]
		})
		if (data) {
			setAttendants(data)
		}
	})

	const handleOperatorChange = (operator: ConditionOperator) => {
		onChange({
			type: "contact_account_manager",
			operator,
			filterData: condition.filterData
		})
	}

	const handleAttendantChange = (attendant: UserInInstance | null) => {
		onChange({
			type: "contact_account_manager",
			operator: condition.operator,
			filterData: { account_manager_user_id: attendant?.id ?? 0 }
		})
	}

	const selectedAttendant = attendants.find(a => a.id === condition.filterData?.account_manager_user_id) ?? null

	return (
		<Grid container direction="row" spacing={2}>
			<Grid item xs={4}>
				<FormControl fullWidth variant="outlined" size="small">
					<Select
						variant="outlined"
						value={condition.operator}
						onChange={({ target }) => handleOperatorChange(target.value as ConditionOperator)}
						fullWidth
					>
						{operatorOptions.map(option => (
							<MenuItem key={option.value} value={option.value}>
								{option.label}
							</MenuItem>
						))}
					</Select>
				</FormControl>
			</Grid>

			<Grid item xs={8}>
				<Autocomplete
					options={attendants}
					value={selectedAttendant}
					getOptionLabel={(option) => option.name}
					getOptionSelected={(option, value) => option.id === value.id}
					fullWidth
					onChange={(_, attendant) => handleAttendantChange(attendant)}
					renderInput={(params) => (
						<TextField
							{...params}
							variant="outlined"
							placeholder="Atendente responsável"
						/>
					)}
					size="small"
				/>
			</Grid>
		</Grid>
	)
}

export default ContactAccountManagerFilterCondition
